import invert from "./invert";
import compose from "./compose";
import apply from "./apply";
import bootstrapTransform from "./bootstrapTransform";
import { transform } from "./transform";
import * as helpers from "./opHelpers";
import listDiffOps from "./listDiffOps";

import "./transforms/create_object";
import "./transforms/delete_object";
import "./transforms/update_property";
import "./transforms/stack_create";
import "./transforms/stack_delete";

const append = (dest, op) => {
  if (!op) return;
  Array.isArray(op) ? op.forEach((e) => dest.push(e)) : dest.push(op);
};

const transformComponent = (dest, op1, op2, side) => {
  const transformedOps = transform(op1, op2, side);
  append(dest, transformedOps);
  return dest;
};

const transformer = {};
bootstrapTransform(transformer, transformComponent, append);

const emptyDocument = {
  objects: {},
  stack: [],
};

// Define the OT type.
const type = {
  name: "whiteboard",
  uri: "https://github.com/aha-app/ot-whiteboard",

  create: (data) => {
    if (data) {
      return data;
    } else {
      return JSON.parse(JSON.stringify(emptyDocument));
    }
  },

  apply,
  compose,
  transform: transformer.transform,
  transformX: transformer.transformX,
  invert,

  // Helper method for creating ops from two lists.
  listDiffOps,

  // Helper methods for creating operations.
  ...helpers,
};

export default { type };
